"use strict";

angular.module('app.factories.interval', []).// app.factories.info-module

// -------------------------------------------//
//               f_Info is for Popups
// -------------------------------------------//

factory('f_Interval', ['$timeout',
    function ($timeout) {

        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            }
        }
        var RunStatus = function () {
            function RunStatus(name) {
                _classCallCheck(this, RunStatus);

                this.name = name;
            }

            _createClass(RunStatus, [{
                key: 'toString',
                value: function toString() {
                    return 'RunStatus.' + this.name;
                }
            },
            {
                key: 'getName',
                value: function getName() {
                    return this.name;
                }
            }
            ]);

            return RunStatus;
        }();
        RunStatus.Paused = new RunStatus('Paused');
        RunStatus.Running = new RunStatus('Running');
        RunStatus.Unregistered = new RunStatus('Unregistered');
        var obj = {
            intervals: [],
            // -------------------------------------------//
            //               Add new Info
            // -------------------------------------------//
            registerInterval: function (i, withInitialCall) {

                if (!i || i.AppId === undefined) {
                    return false;
                }
                i.runStatus = false;

                if (i.options === undefined) {
                    i.options = {};
                }
                i.call = function () {
                    if (i.delay <= 0) {// console.log('Interval '+ i.AppId+' is at delay:0 => no call');
                        return;
                    }
                    //console.log('call'+ i.AppId);
                    if (i.runStatus !== RunStatus.Paused.getName()) {
                        i.runStatus = RunStatus.Running.getName();
                        // run interval function
                        var promise = i.fn( i.getOptions() );
                        // check whether return object exists

                        if (promise) {
                            // check whether return object is a promise
                            if (!(!!promise.then && typeof promise.then === 'function')) {
                                console.warn('interval return object has to be a promise');
                                return;
                            }
                            // restart interval after successful callback
                            promise.then(function () {
                                console.debug('Promise then of'+ i.AppId+'-'+ i.runStatus);
                                if (i.runStatus !== RunStatus.Unregistered.getName() && i.runStatus !== RunStatus.Paused.getName()) {
                                    console.debug(''+ i.AppId+'- success starting runStatus:'+ i.runStatus);
                                    i.success();
                                }
                            });
                        } else {
                            i.success();
                        }

                    }

                };

                i.success = function () {
                    i.stopTimeout(function () {
                        i.timeout = $timeout(i.call, i.delay);
                    });
                };

                i.stopTimeout = function (fn) {

                    $timeout.cancel(i.timeout);
                    if (fn) fn();
                };

                i.pause = function () {
                    i.runStatus = RunStatus.Paused.getName();
                    $timeout.cancel(i.timeout);
                };

                i.restart = function (call) {
                    this.runStatus = RunStatus.Running.getName();
                    if (i.timeout) {
                        $timeout.cancel(i.timeout);
                    }
                    this.timeout = $timeout(this.call, this.delay);
                    if (call) {
                        this.call();
                    }
                };

                i.setOptions = function (o) {
                    for (var key in o) {
                        if (o.hasOwnProperty(key)) {
                            i.options[key] = o[key];
                        }
                    }
                    i.pause();
                    i.restart();

                };

                i.getOptions = function () {
                    return i.options;
                };

                if (obj.intervals.length > 0) {

                    var si = obj.getIntervalByAppId(i.AppId);
                    if (si !== undefined && si !== false) {
                        if (obj.intervals[si.Pos]) {
                            obj.intervals[si.Pos].stopTimeout(function () {
                                    obj.intervals.splice(si.Pos, 1);
                                }
                            );

                            obj.intervals.push(i);
                        } else {
                            obj.intervals.push(i);
                        }

                    } else {
                        obj.intervals.push(i);
                    }
                } else {
                    obj.intervals.push(i);
                }
                if (withInitialCall !== undefined && withInitialCall === true) {
                    i.call();
                } else {
                    i.timeout = $timeout(i.call, i.delay);
                }
                return i.AppId;
            },
            // -----------------------1--------------------//
            //               Get the next Info
            // -------------------------------------------//
            pauseIntervalByAppId: function (i) {
                var iv = obj.getIntervalByAppId(i);
                if (iv && iv.Interval) {
                    iv.Interval.pause();
                }
                return iv.Interval;
            },
            restartIntervalByAppId: function (i, call) {
                var iv = obj.getIntervalByAppId(i);
                if (iv && iv.Interval) iv.Interval.restart(call);
                return iv.Interval;
            },
            unregisterInterval: function (i) {
                i.runStatus = RunStatus.Unregistered.getName();
                i.stopTimeout();
                return obj.intervals.splice(i, 1);
            },
            unregisterAllNonContinousInterval: function () {
                if (obj.intervals.length > 0) {
                    for (var j = obj.intervals.length - 1; j >= 0; j--) {
                        if (!obj.intervals[j].Continous || obj.intervals[j].Continous === undefined) {

                            var fi = obj.intervals[j];
                            //console.log('Unregister inteval!!!'+fi.AppId);
                            fi.stopTimeout();
                            var splicer = j;
                            obj.intervals.splice(splicer, 1);
                        }
                    }
                }
            },
            unregisterAllIntervals: function () {
                if (obj.intervals.length > 0) {
                    for (var j = obj.intervals.length - 1; j >= 0; j--) {
                        var fi = obj.intervals[j];
                        fi.stopTimeout();
                        var splicer = j;
                        obj.intervals.splice(splicer, 1);
                    }
                }
            },
            unregisterIntervalByAppId: function (i) {
                var fi;
                let splicer;
                if (obj.intervals.length > 0) {
                    //console.log('----->unregister'+i);
                    for (var j = 0; j < obj.intervals.length; j++) {
                        if (obj.intervals[j].AppId === i) {
                            obj.intervals[j].stopTimeout();
                            obj.intervals[j].runStatus = RunStatus.Unregistered.getName();
                            fi = obj.intervals[j];
                            splicer = j;
                            break;
                        }
                    }
                }
                if (fi !== undefined) {
                    fi.stopTimeout(function () {

                        obj.intervals.splice(splicer, 1);
                    });
                    return this;
                } else {
                    return false;
                }
            },
            getIntervalByAppId: function (i) {
                if (obj.intervals.length > 0) {
                    for (var j = 0; j < obj.intervals.length; j++) {
                        if (obj.intervals[j].AppId === i) {
                            var fi = obj.intervals[j];
                            var splicer = j;
                            return {'Interval': fi, 'Pos': splicer};
                        }
                    }
                }
                return false;
            },
            pauseAllRunningInvervals: function () {
                if (obj.intervals.length > 0) {
                    for (var j = 0; j < obj.intervals.length; j++) {
                        var i = obj.intervals[j];
                        if (i && i.runStatus !== RunStatus.Paused.getName() && i.stopProtected === undefined) {
                            if (i && i.AppId !== undefined) {
                                i.runStatus = RunStatus.Paused.getName();
                            }
                        }
                    }
                }
            },
            restartAllInvervalsAfterPause: function () {
                if (obj.intervals.length > 0) {
                    for (var j = 0; j < obj.intervals.length; j++) {
                        var i = obj.intervals[j];
                        if (i.runStatus === RunStatus.Paused.getName()) {
                            i.restart();
                        }
                    }
                }
            }

        };


        return obj;

    }]);
